import { createMsgSend, generateTypes } from '@evmos/eip712';
import { createMsgConvertERC20, MSG_CONVERT_ERC20_TYPES, MSG_SEND_TYPES } from '@evmos/eip712';
import { createMsgSend as protoMsgSend, createMsgConvertERC20 as protoMsgConvertErc20 } from '@evmos/proto';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { MsgSendParams, EIP712TypedData } from '@evmos/transactions';
import { MsgConvertERC20Params } from '@evmos/transactions';
import { MsgSend } from 'cosmjs-types/cosmos/bank/v1beta1/tx';
import { fromDuration, fromTimestamp, toDuration, toTimestamp } from 'cosmjs-types/helpers';

export const createTxMsgSendErc20 = (
  context: TxContext,
  params: [ MsgConvertERC20Params, MsgSendParams ],
): TxPayload => {
  const typedData = createEIP712MsgSendErc20(context, params);
  const cosmosMsg = createCosmosMsgSendErc20(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createCosmosMsgSendErc20 = (context: TxContext, params: [ MsgConvertERC20Params, MsgSendParams ]): any => {
  const [ convertErc20Params, sendParams ] = params;
  const convertErc20Message = protoMsgConvertErc20(
    convertErc20Params.contractAddress,
    convertErc20Params.amount,
    convertErc20Params.receiverBech32,
    convertErc20Params.senderHex,
  );
  const sendMessage = protoMsgSend(
    context.sender.accountAddress,
    sendParams.destinationAddress,
    sendParams.amount,
    sendParams.denom,
  );
  return [ convertErc20Message, sendMessage ];
};

const createEIP712MsgSendErc20 = (
  context: TxContext,
  params: [ MsgConvertERC20Params, MsgSendParams ],
): EIP712TypedData => {
  const types = generateTypes({
      MsgValue: [
        { name: 'contract_address', type: 'string', optional: true },
        { name: 'amount', type: 'string', optional: true },
        { name: 'receiver', type: 'string', optional: true },
        { name: 'sender', type: 'string', optional: true },
        { name: 'from_address', type: 'string', optional: true },
        { name: 'to_address', type: 'string', optional: true },
        { name: 'type_amount', type: 'TypeAmount[]', optional: true },
      ],
      TypeAmount: [
        { name: 'denom', type: 'string' },
        { name: 'amount', type: 'string' },
      ],
    },
  );
  const [ convertErc20Params, sendParams ] = params;
  const convertErc20Message = createMsgConvertERC20(
    convertErc20Params.contractAddress,
    convertErc20Params.amount,
    convertErc20Params.receiverBech32,
    convertErc20Params.senderHex,
  );
  (convertErc20Message.value as any).from_address = '';
  (convertErc20Message.value as any).to_address = '';
  (convertErc20Message.value as any).type_amount = [];

  const sendMessage = createMsgSend(
    sendParams.amount,
    sendParams.denom,
    context.sender.accountAddress,
    sendParams.destinationAddress,
  );
  (sendMessage.value as any).type_amount = sendMessage.value.amount;
  (sendMessage.value as any).contract_address = '';
  (sendMessage.value as any).amount = '';
  (sendMessage.value as any).receiver = '';
  (sendMessage.value as any).sender = '';

  return { types, message: [ convertErc20Message, sendMessage ] };
};

